import styled from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
export const WebViewContainer = styled.div`
  backgroundcolor: ${(props) => props.theme.color.gray100};
  overflow: "scroll";
`;

export const NoLoyaltyText = styled.p`
  color: ${(props) => props.theme.color.gray400};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-size: ${(props) => props.theme.fontSize.headline};
  text-align: center;
  margin-top: 45vh;
`;

export const HeaderContainer = styled.div`
  background-color: ${(props) => props.theme.color.white};
  position: fixed;
  width: 100%;
  z-index: 1;
`;

export const HeaderSkirt = styled.div`
  height: ${(props) => props.theme.spacing20};
  background-color: ${(props) => props.theme.color.gray100};
`;

export const PageTitle = styled.p`
  color: ${(props) => props.theme.color.black};
  font-weight: ${(props) => props.theme.fontWeight.normal};
  font-size: ${(props) => props.theme.fontSize.headline};
  text-align: center;
  margin: ${(props) => props.theme.spacing12};
`;

export const ContentContainer = styled.div`
  background-color: ${(props) => props.theme.color.gray100};
  min-height: ${(props) => props.dimensions.height}px;
  padding-top: ${(props) => props.theme.spacing16};
  padding-bottom: 80px;
  text-align: left;
`;

export const FieldContainer = styled.div`
  margin: ${(props) => props.theme.spacing16};
  color: black;
  background: white;
  border-radius: 8px;
  padding: ${(props) => props.theme.spacing16};
  box-shadow: 3px 2px 4px ${(props) => props.theme.color.gray200};
`;

export const FieldTitle = styled.p`
  color: ${(props) => props.theme.color.gray600};
  font-size: ${(props) => props.theme.fontSize.subhead};
  padding: 0;
  margin: 0;
`;

export const FieldValue = styled.p`
  color: ${(props) => props.theme.color.black};
  font-size: ${(props) => props.theme.fontSize.body1};
  padding: 0;
  padding-top: ${(props) => props.theme.spacing4};
  margin: 0;
`;

export const StyledInput = styled.input`
  padding: 12px 12px; /* Increased padding for more height */
  border: 1px solid #e0e0e0; /* Light gray border */
  border-radius: 8px; /* Rounded corners for the input field */
  background-color: #fff;
  font-size: ${(props) => props.theme.fontSize.body1};
  color: #333; /* Dark text color for readability */
  margin-top: ${(props) => props.theme.spacing8};
  width: 100%;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
  height: 50px; /* Explicit height for the input field to ensure it’s tall enough */

  &::placeholder {
    color: #bbb; /* Lighter gray color for the placeholder */
    font-size: ${(props) => props.theme.fontSize.body2};
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.color.pink500};
  }

  /* Improve native date/week/month pickers */
  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
    opacity: 0.7;
  }
  &::-webkit-datetime-edit,
  &::-webkit-datetime-edit-fields-wrapper {
    padding: 0 2px;
  }
`;

// Match NewStore input look for <select>
export const StyledSelect = styled.select`
  padding: 12px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fff;
  font-size: ${(props) => props.theme.fontSize.body1};
  color: #333;
  margin-top: ${(props) => props.theme.spacing8};
  width: 100%;
  box-sizing: border-box;
  height: 50px;
  appearance: none; /* Remove native styling where possible */
  -webkit-appearance: none;
  -moz-appearance: none;

  /* Custom dropdown arrow */
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8' fill='none'><path d='M1 1l5 5 5-5' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px 8px;
  padding-right: 40px; /* space for the arrow */
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.color.pink500};
  }
`;

export const StyledButton = styled.button`
  padding: 12px 20px;
  background-color: ${(props) => props.theme.color.pink500};
  color: white;
  font-size: ${(props) => props.theme.fontSize.body1};
  border-radius: 8px; /* Rounded corners for the button */
  border: none;
  margin-top: 20px;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box; /* Ensures padding doesn't affect width */

  &:hover {
    background-color: ${(props) => props.theme.color.pink700};
  }
`;

export const Label = styled.label`
  font-size: ${(props) => props.theme.fontSize.body1};
  color: ${(props) => props.theme.color.black};
  margin-bottom: ${(props) => props.theme.spacing2};
  font-weight: bold;
`;

export const ErrorMessage = styled.p`
  color: ${(props) => props.theme.color.pink500};
  margintop: ${(props) => props.theme.spacing8};
`;

// Checkbox styled to match NewStore theme
export const StyledCheckbox = styled.input.attrs({ type: "checkbox" })`
  width: 18px;
  height: 18px;
  margin-top: ${(props) => props.theme.spacing8};
  accent-color: ${(props) => props.theme.color.pink500};
  border-radius: 4px;
  cursor: pointer;
`;

// Constrain width and center content with side padding
export const CenteredColumn = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 0 ${(props) => props.theme.spacing16};
  box-sizing: border-box;
`;

// NewStore-style card field: label + control in one surface
export const FieldCard = styled.div`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: ${(p) => p.theme.buttonRadius || "12px"};
  padding: 12px 16px;
  margin: ${(p) => p.theme.spacing8} 0;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  display: grid;
  gap: 6px;
  transition: border-color 120ms ease, box-shadow 120ms ease;

  &:focus-within {
    border-color: ${(p) => p.theme.color.pink500};
    box-shadow: 0 0 0 3px rgba(210, 56, 110, 0.15);
  }
`;

export const FieldLabel = styled.div`
  color: ${(p) => p.theme.color.black};
  font-weight: ${(p) => p.theme.fontWeight.semiBold || 600};
  font-size: ${(p) => p.theme.fontSize.subhead};
  margin: 0;
`;

// Borderless controls inside the card
export const CardInput = styled(StyledInput)`
  margin-top: 0;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;

  &:focus {
    border: none;
    outline: none;
  }
`;

export const CardSelect = styled(StyledSelect)`
  margin-top: 0;
  height: 28px;
  padding: 0;
  border: none;
  background-color: transparent;
  background-position: right 0 center;
  padding-right: 24px;

  &:focus {
    border: none;
    outline: none;
  }
`;

// Inline status banner for success / error messages
export const StatusBanner = styled.div`
  margin-top: ${(p) => p.theme.spacing8};
  padding: 10px 12px;
  border-radius: 8px;
  font-size: ${(p) => p.theme.fontSize.body2};
  line-height: 1.3;
  background-color: ${(p) =>
    p.variant === "error"
      ? p.theme.color.red50 || "#FDE8EA"
      : p.theme.color.green200};
  color: ${(p) => (p.variant === "error" ? p.theme.color.red500 : "#0B3D2E")};
  border: 1px solid
    ${(p) =>
      p.variant === "error" ? p.theme.color.red500 : p.theme.color.green500};
`;

// Toggle switch (replaces checkbox)
export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;

  /* hide native checkbox */
  input {
    opacity: 0;
    width: 0;
    height: 0;
    position: absolute;
  }

  /* slider */
  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e0e0e0;
    transition: 0.2s ease;
    border-radius: 999px;
  }

  span::before {
    content: "";
    position: absolute;
    height: 18px;
    width: 18px;
    left: 3px;
    top: 3px;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    transition: 0.2s ease;
  }

  input:checked + span {
    background-color: ${(p) => p.theme.color.pink500};
  }

  input:checked + span::before {
    transform: translateX(20px);
  }

  input:focus + span {
    box-shadow: 0 0 0 3px rgba(210, 56, 110, 0.15);
  }
`;

export const NSDatePicker = styled(DatePicker)`
  width: 95%;
  padding: 8px 0px 10px 25px !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  background: #fff;
  font-size: 14px;
  font-family: inherit;

  &:focus {
    border: 1px solid #008ac2;
    box-shadow: 0 0 0 3px rgba(0, 138, 194, 0.12);
  }
`;
